var map = {
	"./doihavethatcard_1100x563.webp": 982,
	"./doihavethatcard_300x153.webp": 500,
	"./doihavethatcard_630x322.webp": 298,
	"./killinketo_1100x561.webp": 818,
	"./killinketo_300x152.webp": 368,
	"./killinketo_630x321.webp": 111,
	"./notreallybros_1100x556.webp": 501,
	"./notreallybros_300x151.webp": 381,
	"./notreallybros_630x318.webp": 172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;